module.exports = Promise.resolve(parcelRequire("8uVUi"))